import {
  AssetActionEnum,
  AssetEvent as AssetEventDto,
  AssetEventCategory,
  AssetEventSource,
  AssetFileType,
  AssetFileUploadStatus,
  AssetFileWithURL as AssetFileWithURLDto,
  AssetLog as AssetLogDto,
  AssetLogWithChildren as AssetLogWithChildrenDto,
  CalculatedEventTypes,
  DirectoryInsightEventType,
  EmployeeStatusEnum,
  ShipmentAsset as ShipmentAssetDto,
  StorefrontAsset as StorefrontAssetDto,
  WarehouseMetrics as WarehouseMetricsDto,
} from '@electricjs/core_entity-client';

import { mockHqWarehouseSite, mockOrganizationId } from '@/mocks/data/siteData';
import { Asset } from '@/types/assets';

// Create a mock mac Asset for a mac computer
export const mockMac: Asset = {
  id: 'bd46fce5-bc6b-403d-ab12-94a059ea0cec',
  name: 'MacBookPro15,2',
  productType: {
    id: '6c41bac2-1644-4ec9-982e-cad40c2d38ee',
    name: 'laptop',
    taxCode: 'PC070000',
    allowsWarehousing: true,
    isVirtual: false,
    taaApplicable: true,
  },
  condition: 'NEW',
  customAssetId: '00000004',
  purchasedFromUrl: '',
  brand: '',
  model: 'MacBookPro15,2',
  serialNumber: 'C02ZK4W4LVDL',
  site: null,
  notes: '',
  internalNotes: '',
  status: 'IN_USE',
  imageUrl: '',
  assignedTo: 'da1433df-6b92-4489-971e-dc7be9411c8f',
  assignedToEmployee: {
    id: 'da1433df-6b92-4489-971e-dc7be9411c8f',
    firstName: 'Tom',
    lastName: 'McGurl',
  },
  createdAt: '2024-07-15T17:59:22.622000+00:00',
  updatedAt: '2024-09-17T01:19:37.926257+00:00',
  device: {
    id: '08b3491e-293b-4877-8378-ea290b4e4e50',
    osType: 'darwin',
    lockStatus: 'UNLOCKED',
    mdmEnrolledAt: '2024-07-15T17:59:22.622000+00:00',
    reportingData: {
      hostname: 'C02ZK4W4LVDL-tommcgurl',
      osVersion: '14.4.0',
      osName: 'Sonoma',
      ramCapacity: 16,
      storageCapacity: 420,
      storageAvailable: 350,
      storageUsagePercent: 15.8,
      filevault: true,
      filevaultStatus: 'on',
      filevaultEncryptionPercent: 100,
      encryption: true,
      encryptionPercent: 100,
      batteryHealth: 'check_battery',
      firewall: true,
      gatekeeper: true,
      issues: {
        batteryHealth: {
          category: 'healthAnd_performance',
          actual: 'checkBattery',
          expected: 'good',
          extra: undefined,
        },
      },
      lastOsqueryReport: '2024-09-17T01:19:37.926257+00:00',
      storageInUse: 196.08,
      lastOsqueryEnrollment: '2024-08-22T19:31:45.706534+00:00',
    },
    hardwareModel: 'MacBookPro15,2',
    lockPin: '1234',
    createdAt: '2024-07-15T17:59:22.622000+00:00',
    updatedAt: '2024-09-17T01:19:37.926257+00:00',
  },
  locationId: null,
};

export const mockPC: Asset = {
  id: '14937f78-9800-426f-9c7e-8860f6dc6c4c',
  name: 'Latitude',
  internalNotes: '',
  productType: {
    id: '6c41bac2-1644-4ec9-982e-cad40c2d38ee',
    name: 'laptop',
    taxCode: 'PC070000',
    allowsWarehousing: true,
    isVirtual: false,
    taaApplicable: true,
  },
  customAssetId: '00000017',
  purchasedFromUrl: '',
  brand: '',
  model: 'Latitude',
  serialNumber: 'AWQZN2MN1I6',
  site: null,
  notes: '',
  status: 'DISPOSED',
  condition: 'NEW',
  imageUrl: '',
  assignedTo: 'be3bcb27-b2f0-459a-9e65-e38f9ef0e874',
  assignedToEmployee: {
    id: 'be3bcb27-b2f0-459a-9e65-e38f9ef0e874',
    firstName: 'Thomas',
    lastName: 'Edison',
  },
  createdAt: '2024-07-15T17:59:22.622000+00:00',
  updatedAt: '2024-09-17T01:19:37.926257+00:00',
  device: {
    id: '450361d5-4d4e-4f16-9a8b-c7f9611efb48',
    osType: 'windows',
    lockStatus: 'LOCKED',
    reportingData: {
      osVersion: '10.0.22631',
      osName: 'Windows XD',
      ramCapacity: 5,
      storageCapacity: 245.11,
      storageAvailable: 184.12,
      storageUsagePercent: 24.88,
      filevault: true,
      filevaultEncryptionPercent: 100,
      bitlocker: true,
      bitlockerStatus: 'encrypted',
      bitlockerEncryptionPercent: 100,
      encryption: true,
      encryptionPercent: 100,
      batteryHealth: 'good',
      firewall: true,
      gatekeeper: true,
      issues: {
        ram: {
          category: 'healthAndPerformance',
          actual: 5,
          expected: 8,
          extra: undefined,
        },
      },
      storageInUse: 60.98,
    },
    hardwareModel: 'Latitude',
    lockPin: '1234',
    createdAt: '2024-07-15T17:59:22.622000+00:00',
    updatedAt: '2024-09-17T01:19:37.926257+00:00',
  },
  locationId: null,
};

export const mockEmpty: Asset = {
  id: '14937f78-9800-426f-9c7e-8860f6dc6c4c',
  name: 'Latitude',
  productType: {
    id: '6c41bac2-1644-4ec9-982e-cad40c2d38ee',
    name: 'laptop',
    taxCode: 'PC070000',
    allowsWarehousing: true,
    isVirtual: false,
    taaApplicable: true,
  },
  internalNotes: '',
  customAssetId: '00000017',
  purchasedFromUrl: '',
  brand: '',
  model: 'Latitude',
  serialNumber: 'AWQZN2MN1I6',
  site: null,
  notes: '',
  status: 'DISPOSED',
  condition: 'NEW',
  imageUrl: '',
  assignedTo: 'be3bcb27-b2f0-459a-9e65-e38f9ef0e874',
  assignedToEmployee: {
    id: 'be3bcb27-b2f0-459a-9e65-e38f9ef0e874',
    firstName: 'Thomas',
    lastName: 'Edison',
  },
  createdAt: '2024-07-15T17:59:22.622000+00:00',
  updatedAt: '2024-09-17T01:19:37.926257+00:00',
  device: null,
  locationId: null,
};

// Richer shipment-eligible variants (mirrors the real `ShipmentAsset` API
// shape returned by the eligible-for-shipment endpoint — snake_case, with a
// PII-enriched assigned employee and a site with a hydrated address). Kept
// as raw DTO shapes (not the FE `ShipmentEligibleAsset` type) so MSW
// actually exercises `transformShipmentEligibleAsset`'s snake_case mapping,
// the same way the real API response would.
const mockDtoProductType = {
  id: mockMac.productType.id,
  name: mockMac.productType.name,
  tax_code: mockMac.productType.taxCode,
  is_virtual: mockMac.productType.isVirtual,
  allows_warehousing: mockMac.productType.allowsWarehousing,
  taa_applicable: mockMac.productType.taaApplicable,
};

export const mockShipmentEligibleMac: ShipmentAssetDto = {
  id: mockMac.id,
  name: mockMac.name,
  product_type: mockDtoProductType,
  organization_id: mockOrganizationId,
  custom_asset_id: mockMac.customAssetId,
  purchased_from_url: mockMac.purchasedFromUrl,
  brand: mockMac.brand,
  model: mockMac.model,
  serial_number: mockMac.serialNumber,
  notes: mockMac.notes,
  internal_notes: mockMac.internalNotes,
  status: mockMac.status,
  image_url: mockMac.imageUrl,
  assigned_to: mockMac.assignedTo,
  assigned_to_employee: {
    id: mockMac.assignedToEmployee!.id,
    first_name: mockMac.assignedToEmployee!.firstName,
    last_name: mockMac.assignedToEmployee!.lastName,
    status: EmployeeStatusEnum.Active,
    email: 'tom.mcgurl@example.com',
    phone_number: '2125559876',
    address: {
      street_1: '123 Main St',
      street_2: '',
      city: 'New York',
      state: 'NY',
      zip_code: '10001',
      country: 'US',
    },
  },
  created_at: mockMac.createdAt,
  updated_at: mockMac.updatedAt,
  site: undefined,
};

export const mockShipmentEligiblePC: ShipmentAssetDto = {
  id: mockPC.id,
  name: mockPC.name,
  product_type: mockDtoProductType,
  organization_id: mockOrganizationId,
  custom_asset_id: mockPC.customAssetId,
  purchased_from_url: mockPC.purchasedFromUrl,
  brand: mockPC.brand,
  model: mockPC.model,
  serial_number: mockPC.serialNumber,
  notes: mockPC.notes,
  internal_notes: mockPC.internalNotes,
  status: mockPC.status,
  image_url: mockPC.imageUrl,
  assigned_to: mockPC.assignedTo,
  assigned_to_employee: {
    id: mockPC.assignedToEmployee!.id,
    first_name: mockPC.assignedToEmployee!.firstName,
    last_name: mockPC.assignedToEmployee!.lastName,
    status: EmployeeStatusEnum.Active,
    email: 'thomas.edison@example.com',
    // No phone/address on file for this employee — exercises the
    // site-address/site-phone fallback path in the prefill effect.
  },
  created_at: mockPC.createdAt,
  updated_at: mockPC.updatedAt,
  site: mockHqWarehouseSite,
};

export const mockStorefrontAssets: StorefrontAssetDto[] = [
  { ...mockShipmentEligibleMac, is_shippable: true, self_ship_required: false },
  { ...mockShipmentEligiblePC, is_shippable: false, self_ship_required: true },
];

export const mockAssetLogs: AssetLogDto[] = [
  {
    id: 'a1f0c0de-1111-4a11-8a11-000000000001',
    asset_id: mockMac.id,
    action: AssetActionEnum.Assign,
    description: 'Asset assigned to Tom McGurl',
    performed_at: '2024-08-01T15:00:00.000000+00:00',
    created_at: '2024-08-01T15:00:00.000000+00:00',
    updated_at: '2024-08-01T15:00:00.000000+00:00',
  },
  {
    id: 'a1f0c0de-1111-4a11-8a11-000000000002',
    asset_id: mockMac.id,
    action: AssetActionEnum.ChangeStatus,
    description: 'Status changed from AVAILABLE to IN_USE',
    performed_at: '2024-07-20T12:30:00.000000+00:00',
    created_at: '2024-07-20T12:30:00.000000+00:00',
    updated_at: '2024-07-20T12:30:00.000000+00:00',
  },
];

// Unresolved device issue with a reminder child, as returned by
// GET /devices/issues/unresolved.
export const mockUnresolvedAssetLogs: AssetLogWithChildrenDto[] = [
  {
    id: 'a1f0c0de-2222-4a22-8a22-000000000001',
    asset_id: mockMac.id,
    action: AssetActionEnum.DeviceIssueCreated,
    description: 'Battery health needs attention',
    performed_at: '2024-09-10T09:00:00.000000+00:00',
    created_at: '2024-09-10T09:00:00.000000+00:00',
    updated_at: '2024-09-10T09:00:00.000000+00:00',
    children: [
      {
        id: 'a1f0c0de-2222-4a22-8a22-000000000002',
        asset_id: mockMac.id,
        action: AssetActionEnum.DeviceIssueReminder,
        description: 'Reminder sent to employee',
        performed_at: '2024-09-12T09:00:00.000000+00:00',
        parent_asset_log_id: 'a1f0c0de-2222-4a22-8a22-000000000001',
        created_at: '2024-09-12T09:00:00.000000+00:00',
        updated_at: '2024-09-12T09:00:00.000000+00:00',
      },
    ],
  },
];

export const mockAssetImages: AssetFileWithURLDto[] = [
  {
    file_id: 'f11e0001-0000-4000-8000-000000000001',
    url: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7',
    file_name: 'front.gif',
    asset_id: mockMac.id,
    file_size_bytes: 43,
    file_type: AssetFileType.Image,
    upload_status: AssetFileUploadStatus.Uploaded,
    created_at: '2024-08-01T15:00:00.000000+00:00',
    updated_at: '2024-08-01T15:00:00.000000+00:00',
  },
];

export const mockWarehouseMetrics: WarehouseMetricsDto = {
  asset_count: { previous_month: 12, current_month: 15 },
};

export const mockAssetEvents: AssetEventDto[] = [
  {
    action: 'Device locked',
    date: '2024-09-15T10:00:00.000000+00:00',
    action_type: CalculatedEventTypes.DeviceLock,
    category: AssetEventCategory.Security,
    source: AssetEventSource.AssetLog,
    performed_by: 'Admin User',
  },
  {
    action: 'Asset assigned',
    date: '2024-08-01T15:00:00.000000+00:00',
    action_type: AssetActionEnum.Assign,
    category: AssetEventCategory.Asset,
    source: AssetEventSource.AssetLog,
    performed_by: 'Admin User',
  },
  {
    action: 'Login attempt',
    date: '2024-08-05T13:30:00.000000+00:00',
    action_type: DirectoryInsightEventType.LoginAttempt,
    category: AssetEventCategory.Security,
    source: AssetEventSource.AssetLog,
  },
];
